import React from 'react';

import { useLayoutContext } from '@contexts/LayoutContext';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import BookSelectorPanel from '@components/BookSelectorForPackages/BookSelectorPanel';
import { PackageTargetHeader } from '@components/BookSelectorForPackages/PackageTargetHeader';
import NwBullet from '@components/Gui/NwBullet';
import NwDrawer from '@components/Gui/NwDrawer';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/**
 * Selettore di book aperto dal PackageDrawer. Package e gruppo li ha già decisi chi apre
 * il drawer, quindi qui sono solo dichiarati: cambiare gruppo da qui sposterebbe la
 * modella, e una modella non può stare in due gruppi.
 */
const BookSelectorDrawer = ({
    addedPlaylists,
    contactID,
    onAddBook,
    onClose,
    onRemoveBook,
    packageGroup,
    packageName,
}) => {
    const { isMobile } = useLayoutContext();

    const header = (
        <PackageTargetHeader>
            <div className="package-target-fixed">
                <span className="package-target-name">{packageName}</span>
                {packageGroup && (
                    <>
                        <NwBullet />
                        <NwIcon icon={byPrefixAndName.fasl['people-group']} />
                        <span className="package-target-group-name">{packageGroup}</span>
                    </>
                )}
            </div>
        </PackageTargetHeader>
    );

    return (
        <NwDrawer
            title={`${getContactName(contactID)}'s books`}
            // Niente padding e fondo grigio: le card del pannello si appoggiano lì sopra
            padding="0"
            whiteBg={false}
            // Il pannello riempie il corpo: così a scorrere è la lista, non tutto il drawer
            bodyStyle={isMobile ? undefined : { display: 'flex', flexDirection: 'column' }}
            onClose={onClose}
        >
            <BookSelectorPanel
                addedPlaylists={addedPlaylists}
                contactID={contactID}
                fillHeight={!isMobile}
                header={header}
                packageGroup={packageGroup}
                packageName={packageName}
                onAddBook={onAddBook}
                onRemoveBook={onRemoveBook}
            />
        </NwDrawer>
    );
};

export default BookSelectorDrawer;
